import { render } from "./3_laboratorio.vue?vue&type=template&id=08f7c094&scoped=true"
import script from "./3_laboratorio.vue?vue&type=script&lang=js"
export * from "./3_laboratorio.vue?vue&type=script&lang=js"

import "./3_laboratorio.vue?vue&type=style&index=0&id=08f7c094&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f7c094"]])

export default __exports__